import { withInstall } from '@lit-element/utils'
import Watermark from './src/watermark.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtWatermark: SFCWithInstall<typeof Watermark> =
  withInstall(Watermark)
export default LtWatermark

export * from './src/watermark'
